var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_175_4931)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    rx: 2,
    fill: "#F93939"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6687 9.22892L13.4514 9.87959L13.684 8.50039L12.6992 7.52225L14.0611 7.31959L14.6687 6.06519L15.2764 7.32065L16.6383 7.52332L15.6535 8.49932L15.8861 9.87852",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9528 11.7333C11.9778 11.7333 13.6195 10.0618 13.6195 7.99994C13.6195 5.93807 11.9778 4.2666 9.9528 4.2666C7.92775 4.2666 6.28613 5.93807 6.28613 7.99994C6.28613 10.0618 7.92775 11.7333 9.9528 11.7333ZM11.0004 10.6666C12.4461 10.6666 13.6195 9.47194 13.6195 7.99994C13.6195 6.52794 12.4461 5.33327 11.0004 5.33327C9.5547 5.33327 8.38137 6.52794 8.38137 7.99994C8.38137 9.47194 9.5547 10.6666 11.0004 10.6666Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTr);
export default __webpack_public_path__ + "static/media/tr.9952075048e682704d21fb5317e78e50.svg";
export { ForwardRef as ReactComponent };